import { makeStyles } from "tss-react/mui";
import { MiSkeleton, SKELETON_VARIANTS } from "@miplatform/components";
import { Fade, Typography } from "@mui/material";

export const MiWorkBoardColumn = ({
  title,
  children,
  count,
  loading,
}: {
  title: string;
  children: React.ReactNode;
  count: number | null;
  loading?: boolean;
}) => {
  const { classes } = useStyles();

  return (
    <div className={classes.columnContainer}>
      <div className={classes.columnHeader}>
        <Typography className={classes.columnCount} variant="subtitle2">
          {loading && !count ? "-" : count}
        </Typography>
        <Typography variant="subtitle2">{title}</Typography>
      </div>
      {loading && !count ? (
        <MiSkeleton
          variant={SKELETON_VARIANTS.RECTANGULAR}
          height="100%"
          className={classes.loader}
        />
      ) : (
        <Fade in={!!count}>
          <div className={classes.columnContent}>{children}</div>
        </Fade>
      )}
    </div>
  );
};

const useStyles = makeStyles()((theme) => ({
  columnContainer: {
    minHeight: "100%",
    padding: theme.spacing(1),
    backgroundColor: theme.palette.info.light,
    borderRadius: 4,
    display: "flex",
    flexDirection: "column",
  },
  columnHeader: {
    backgroundColor: theme.palette.common.white,
    borderRadius: 2,
    padding: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  columnCount: {
    fontSize: "0.6875rem",
    color: theme.palette.common.white,
    fontWeight: 500,
    height: 20,
    minWidth: 20,
    borderRadius: "10px",
    padding: "0 6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    lineHeight: 1,
    backgroundColor: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.dark}`,
  },
  loader: {
    flex: 1,
    width: "100%",
  },
  columnContent: {
    padding: theme.spacing(1, 0),
    flex: 1,
  },
}));
